export class SheetBase {
  grade: string = ""
  name: string = ""
  curriculum_id: string = ""
  subject_name: string = ""
  exec_date: string = ""
  grade_cache: string = ""
  is_sort_answer_image_enable: boolean = false
}

export class SheetGroup {
  sheet_id: number | null = null
  room_name: string = ""
  room_name_cache: string = ""
  students: Student[] = new Array<Student>()
  is_selectedes: boolean[] = new Array<boolean>();
  is_all_checked: boolean = false
  is_exists_test_started_examinees: boolean = false
}

export class Student {
  grade: number
  room_name: string
  student_no: number
  student_no_character: string
  name: string
  is_test_started: boolean = false

  constructor(grade: number, room_name: string, student_no: number, student_no_character: string, name: string){
    this.grade = grade;
    this.room_name = room_name;
    this.student_no = student_no;
    this.student_no_character = student_no_character;
    this.name = name;
  }
}

export class RoomName {
  grade: number
  room_name: string

  constructor(grade: number, room_name: string){
    this.grade = grade;
    this.room_name = room_name;
  }
}

export class Curriculum {
  id: number
  name: string
  constructor(curriculum: any){
    this.id = curriculum.id;
    this.name = curriculum.name;
  }
}